// extracted by mini-css-extract-plugin
module.exports = {"rowStyle":"syncDetailsModal_rowStyle__2-Nj4","rowItem":"syncDetailsModal_rowItem__O6OOH"};